export default __webpack_public_path__ + "static/media/fire.40b53dac.png";